import { Box } from "@mui/material";

import { AssayBar } from "./components/AssayBar";
import { InvitaeNav } from "./components/InvitaeNav";

export const Header = () => {
  return (
    <Box component="header">
      <InvitaeNav />
      <AssayBar />
    </Box>
  );
};
